/**
 * Dineo Design System - Theme Entry Point
 *
 * Creates the main MUI 7 theme with CSS variables and
 * light/dark color scheme support. Re-exports the KDS theme
 * and motion constants for convenience.
 */

import { createTheme } from '@mui/material/styles';
import { lightPalette, darkPalette } from './palette';
import { typography } from './typography';
import { components } from './components';
import { shadows } from './shadows';
import { breakpoints } from './breakpoints';

export function createAppTheme(direction = 'ltr') {
  return createTheme({
    cssVariables: true,
    colorSchemeSelector: 'class',
    direction,
    colorSchemes: {
      light: { palette: lightPalette },
      dark: { palette: darkPalette },
    },
    typography,
    components,
    shadows,
    breakpoints,
  });
}

const theme = createAppTheme('ltr');

export default theme;
export { kdsTheme } from './kds-theme';
export { duration, easing, spring, pageTransition, reducedMotion } from './motion';
